import TableBody from '@material-ui/core/TableBody'
import { orderSelectors } from 'ducks/orderComponents'
import { memo } from 'react'
import { useSelector } from 'react-redux'
import type { HardwareOrderProjectRecord } from '../../type'
import type { ProjectTablePresenter } from '../projectTablePresenter'
import type { ProjectTableStore } from '../useProjectTable'
import ProjectTableRow from './TableRow'

type ProjectTableContentPropsType = {
  data: HardwareOrderProjectRecord[]
  projectTableStore: ProjectTableStore
  projectTablePresenter: ProjectTablePresenter
  allowEdit?: boolean
}

const ProjectTableContent = ({
  data,
  projectTableStore,
  projectTablePresenter,
  allowEdit = true,
}: ProjectTableContentPropsType) => {
  const selectedProjectIds = useSelector(orderSelectors.getOrderProjectIds)

  return (
    <TableBody>
      {data.map((record) => {
        return (
          <ProjectTableRow
            key={record.id}
            checked={selectedProjectIds.includes(record.id)}
            projectTableStore={projectTableStore}
            projectTablePresenter={projectTablePresenter}
            record={record}
            allowEdit={allowEdit}
          />
        )
      })}
    </TableBody>
  )
}

export default memo(ProjectTableContent)
